import styled, { keyframes } from 'styled-components'
import { SALON_DETAIL } from '../../styles/constants'

/**
 * When changing the styles here, especially the ones that affects the size of the component, update SalonDetail as well.
 * We need to keep the same size for both components to prevent Layout Shift.
 * @see src/components/SalonDetail/SalonDetail.tsx
 */

const translateBackground = keyframes`
    from {
        background-position: 100% 0;
    }
    to {
        background-position: 0 0;
    }
`

export const PlaceholderWrapper = styled.div``

export const PlaceholderContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: ${SALON_DETAIL.TEXT_CONTENT_HEIGHT}px;
`

export const Picture = styled.picture`
	width: 100%;
	height: auto;
	display: block;
`

const PlaceholderBase = styled.div`
	width: 100%;
	border-radius: 4px;
	margin-bottom: 4px;

	background-image: linear-gradient(
		90deg,
		rgb(245, 245, 245),
		rgb(245, 245, 245),
		rgb(245, 245, 245),
		rgb(245, 245, 245),
		rgb(230, 230, 230),
		rgb(245, 245, 245),
		rgb(245, 245, 245),
		rgb(245, 245, 245),
		rgb(245, 245, 245)
	);
	background-size: 300%;
	animation: 2.5s linear 0s infinite normal none running ${translateBackground};
`

export const PlaceholderImage = styled.img`
	aspect-ratio: ${SALON_DETAIL.IMAGE_ASPECT_RATIO};
	margin-bottom: ${SALON_DETAIL.GAP}px;
	object-fit: cover;
	width: 100%;
	height: auto;
	display: block;
`

export const PlaceholderText = styled(PlaceholderBase)`
	height: 22px;
`
